import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { FuelTextField } from '@frete.com/fuel-react';
import { EditAddressType } from '../schema';
import { FieldAddressPropsInterface } from './FieldAddressTypes';

function FieldAddress({ flow }: FieldAddressPropsInterface) {
  const { control, getFieldState, register } =
    useFormContext<EditAddressType>();
  const nameField = `${flow}.place.address` as const;
  const errorField = getFieldState(nameField).error?.message;

  return (
    <Controller
      name={nameField}
      control={control}
      render={({ field: { value, onBlur, onChange } }) => (
        <FuelTextField
          name={nameField}
          type="text"
          placeholder="Informe o endereço"
          data-testid={`input-${nameField}`}
          label="Endereço"
          onInput={onChange}
          onBlur={onBlur}
          ref={register(nameField).ref}
          state={errorField ? 'error' : 'default'}
          hint={errorField}
          value={value}
          maxlength={200}
        />
      )}
      defaultValue=""
    />
  );
}

export default FieldAddress;
